module.exports = __webpack_public_path__ + "img/logo.e465c492.webp";